export default __webpack_public_path__ + "static/media/guest.b4a7afe9.svg";